<template>
  <div v-if="isHeader" class="item is-header">
    <p class="left">{{ $t("item") }}</p>

    <div class="sales">
      <button
          :class="{
          white: store.sort === ComparisonSort.SalesDesc || store.sort === ComparisonSort.SalesAsc
        }"
          class="btn btn-transparent fw400 light gap2"
          @click="
          store.sort =
            store.sort === ComparisonSort.SalesDesc
              ? ComparisonSort.SalesAsc
              : ComparisonSort.SalesDesc
        "
      >
        <span>{{ $t("sales") }}</span>
        <icons-components-sort-icon
            :is-active="
            store.sort === ComparisonSort.SalesDesc || store.sort === ComparisonSort.SalesAsc
          "
            :sort-by="store.sort === ComparisonSort.SalesDesc ? 'desc' : 'asc'"
            default-color="#8E9EBD"
            height="20"
            width="20"
        />
      </button>
    </div>
    <div class="steam-price">
      <button
          :class="{
          white:
            store.sort === ComparisonSort.SteamPriceDesc ||
            store.sort === ComparisonSort.SteamPriceAsc
        }"
          class="btn btn-transparent fw400 light gap2"
          @click="
          store.sort =
            store.sort === ComparisonSort.SteamPriceDesc
              ? ComparisonSort.SteamPriceAsc
              : ComparisonSort.SteamPriceDesc
        "
      >
        <span>{{ $t("steam_price") }}</span>
        <icons-components-sort-icon
            :is-active="
            store.sort === ComparisonSort.SteamPriceDesc ||
            store.sort === ComparisonSort.SteamPriceAsc
          "
            :sort-by="store.sort === ComparisonSort.SteamPriceDesc ? 'desc' : 'asc'"
            default-color="#8E9EBD"
            height="20"
            width="20"
        />
      </button>
    </div>
    <div class="prices-wrapper">
      <div class="min-price">
        <MarketsCheckboxesSelect
            v-model="store.activeFilters.markets_from"
            :items="(store.filters.markets as AvailableMarkets[]) || []"
            :selected-items="store.activeFilters.markets_from as string[]"
            side="for_buying"
        />
      </div>
      <button class="btn btn-transparent px8 swap-btn" @click="swapMarkets">
        <svg class="gray" height="20" width="20">
          <use xlink:href="/icons/sprite.svg#i-swap"></use>
        </svg>
      </button>
      <div class="max-price">
        <MarketsCheckboxesSelect
            v-model="store.activeFilters.markets_to"
            :items="(store.filters.markets as AvailableMarkets[]) || []"
            :selected-items="store.activeFilters.markets_to as string[]"
            side="for_selling"
        />
      </div>
    </div>
    <div class="profit f fs">
      <span class="fw400 light">{{ $t("profit") }}</span>
      <button
          :class="{
          white:
            store.sort === ComparisonSort.ProfitValueAsc ||
            store.sort === ComparisonSort.ProfitValueDesc
        }"
          class="btn btn-transparent fw400 light"
          @click="
          store.sort =
            store.sort === ComparisonSort.ProfitValueDesc
              ? ComparisonSort.ProfitValueAsc
              : ComparisonSort.ProfitValueDesc
        "
      >
        $
      </button>
      |
      <button
          :class="{
          white:
            store.sort === ComparisonSort.ProfitPercentageAsc ||
            store.sort === ComparisonSort.ProfitPercentageDesc
        }"
          class="btn btn-transparent fw400 light"
          @click="
          store.sort =
            store.sort === ComparisonSort.ProfitPercentageDesc
              ? ComparisonSort.ProfitPercentageAsc
              : ComparisonSort.ProfitPercentageDesc
        "
      >
        %
      </button>
      <icons-components-sort-icon
          :is-active="
          store.sort === ComparisonSort.ProfitValueDesc ||
          store.sort === ComparisonSort.ProfitValueAsc ||
          store.sort === ComparisonSort.ProfitPercentageDesc ||
          store.sort === ComparisonSort.ProfitPercentageAsc
        "
          :sort-by="
          store.sort === ComparisonSort.ProfitValueDesc ||
          store.sort === ComparisonSort.ProfitPercentageDesc
            ? 'desc'
            : 'asc'
        "
          default-color="#8E9EBD"
          height="20"
          width="20"
      />
    </div>
    <span class="btn"></span>
  </div>

  <div v-else class="item">
    <div :style="{ background: item.rarity_color as string }" class="item-rarity-color"></div>
    <div class="left f fs">
      <Thumb :item="item" :loading="!isNaN(+index!) && index! <= 10 ? 'eager' : 'lazy'" />
      <svg v-if="item.liked" class="hd red" height="16" width="16">
        <use xlink:href="/icons/sprite.svg#i-heart"></use>
      </svg>
      <Name :item="item" />
    </div>

    <div class="sales f">
      <span class="hlgt">{{ $t("sales") }}</span>
      <span>{{ item.sales?.toLocaleString("ru-RU") }}</span>
    </div>
    <div class="steam-price f">
      <span class="hlgt">{{ $t("steam_price") }}</span>
      <div class="f fs gap4">
        <svg height="20" width="20">
          <use xlink:href="/icons/sprite.svg#i-steam-logo-circle"></use>
        </svg>
        <UiPrice :price="item.steam_price?.price" />
      </div>
    </div>

    <div class="prices-wrapper">
      <AllPrices :item="item" />
    </div>

    <div class="profit f">
      <span class="hlgt">{{ $t("profit") }}</span>

      <div class="f fs gap8">
        <UiPrice :class="[item.profit?.value > 0 ? 'green' : 'red']" :price="item.profit?.value" />
        <p :class="[item.profit?.value > 0 ? 'green' : 'red']" class="fw400">
          ~{{ item.profit?.percentage }}%
        </p>
      </div>
    </div>
    <button
        :class="{ hided: item.hided }"
        :disabled="loading"
        class="btn btn-transparent btn-like px13"
        @click="itemHide"
    >
      <svg height="20" width="20">
        <use xlink:href="/icons/sprite.svg#i-eye-crossed"></use>
      </svg>
    </button>
    <button
        :class="{ liked: item.liked }"
        :disabled="loading"
        class="btn btn-transparent btn-like px13"
        @click="itemLike"
    >
      <svg height="16" width="16">
        <use v-if="item.liked" xlink:href="/icons/sprite.svg#i-heart"></use>
        <use v-else xlink:href="/icons/sprite.svg#i-heart-empty"></use>
      </svg>
    </button>

    <div
        v-click-outside="() => (toggle = false)"
        :class="{ opened: toggle }"
        class="mobile-actions hlgt"
    >
      <button class="btn btn-transparent px10" @click="toggle = !toggle">
        <svg height="20" width="20">
          <use xlink:href="/icons/sprite.svg#i-more"></use>
        </svg>
      </button>

      <div class="mobile-actions-menu">
        <button
            aria-label="Copy"
            class="btn btn-transparent gap8 fw500 w-100 fs"
            @click="
            copy();
            toggle = false;
          "
        >
          <svg height="20" width="20">
            <use xlink:href="/icons/sprite.svg#i-copy"></use>
          </svg>
          {{ $t("copy_item_name") }}
        </button>

        <button
            :class="{ 'liked red': item.liked }"
            :disabled="loading"
            class="btn btn-transparent gap8 fw500 w-100 fs"
            @click="
            itemLike();
            toggle = false;
          "
        >
          <svg height="20" width="20">
            <use v-if="item.liked" xlink:href="/icons/sprite.svg#i-heart-broken"></use>
            <use v-else xlink:href="/icons/sprite.svg#i-heart-empty"></use>
          </svg>
          {{ $t(item.liked ? "delete_from_featured" : "add_to_featured") }}
        </button>

        <button
            :class="{ 'hided red': item.hided }"
            :disabled="loading"
            class="btn btn-transparent gap8 fw500 w-100 fs"
            @click="
            itemHide();
            toggle = false;
          "
        >
          <svg height="20" width="20">
            <use xlink:href="/icons/sprite.svg#i-eye-crossed"></use>
          </svg>
          {{ $t(item.hided ? "delete_from_hidden" : "hide") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script lang="ts" setup>
import Thumb from "./Components/Thumb.vue";
import Name from "./Components/Name.vue";
import type {AvailableMarkets, CompareItem} from "~/graphql/generated/schema-types";
import {ComparisonSort} from "~/graphql/generated/schema-types";
import {likeItem} from "~/utils/api";
import {EventBus} from "~/composables/bus";
import {useComparisonStore} from "~/store/comparison";
import MarketsCheckboxesSelect
  from "~/components/Pages/Comparison/Item/Components/MarketsCheckboxesSelect.vue";
import AllPrices from "~/components/Pages/Comparison/Item/Components/AllPrices.vue";
import {notify} from "@kyvg/vue3-notification";

const props = defineProps<{
  item: CompareItem;
  isHeader: boolean;
  index?: number;
}>();
const store = useComparisonStore();

const loading = ref(false);
const toggle = ref(false);
const {t} = useI18n();

const itemLike = async () => {
  loading.value = true;
  try {
    const {data, errors} = await likeItem(props.item.link);
    if (errors?.length) {
      throw new Error(errors[0].message);
    }
    props.item.liked = data?.likeItem;
  } catch (e: any) {
    EventBus.$emit("notify", {
      success: false,
      msg: e?.message || "Something went wrong"
    });
  } finally {
    loading.value = false;
  }
};

const itemHide = async () => {
  loading.value = true;
  try {
    const {data, errors} = await hideItem(props.item.link);
    if (errors?.length) {
      throw new Error(errors[0].message);
    }
    props.item.hided = data?.hideItem;
  } catch (e: any) {
    EventBus.$emit("notify", {
      success: false,
      msg: e?.message || "Something went wrong"
    });
  } finally {
    loading.value = false;
  }
};

const swapMarkets = () => {
  [store.activeFilters.markets_from, store.activeFilters.markets_to] = [
    store.activeFilters.markets_to,
    store.activeFilters.markets_from
  ];
};

const copy = () => {
  navigator.clipboard
      .writeText(props.item.market_hash_name)
      .then(() => {
        notify({
          type: "success",
          title: t("notify.success"),
          text: t("notify.copied")
        });
      })
      .catch(() => {
        notify({
          type: "error",
          title: t("notify.error"),
          text: t("An error occurred")
        });
      });
};
</script>

<style lang="scss" scoped>
.item {
  display: flex;
  align-items: center;
  justify-content: flex-start;
  min-height: 6.8rem;
  width: 100%;
  //min-width: 1175px;
  background: var(--surfaces-low-container);
  border-radius: 8px;
  margin-bottom: 8px;
  padding: 12px;
  position: relative;
  color: var(--surfaces-on-surface-variable);
  font-weight: 600;

  &-rarity-color {
    height: 40px;
    width: 4px;
    border-radius: 0 0.6rem 0.6rem 0;
    margin-right: 8px;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }

  .btn-like {
    color: var(--surfaces-on-surface-variable);

    svg {
      color: var(--surfaces-on-surface-variable);
    }

    &.liked,
    &.hided {
      svg {
        color: var(--destructive);
      }
    }
  }

  &:deep(svg),
  svg {
    flex-shrink: 0;
  }

  .mobile-actions {
    position: absolute;
    top: 12px;
    right: 8px;

    &-menu {
      display: none;
      position: absolute;
      z-index: 1;
      top: 100%;
      right: 0;
      border-radius: 8px;
      border: 1px solid var(--surfaces-outline);
      background: var(--accent-on-primary);
      width: max-content;
    }

    &.opened .mobile-actions-menu {
      display: block;
    }
  }

  .prices-wrapper {
    display: flex;
    align-items: center;
    justify-content: center;
    gap: 4px;
    flex-shrink: 0;
    width: min-content;
    min-width: 305px;
    padding-left: 20px;

    &:deep(.max-price),
    .max-price,
    &:deep(.min-price),
    .min-price {
      width: 130px;
    }

    svg {
      flex-shrink: 0;
    }
  }

  .profit,
  .steam-price {
    flex-shrink: 0;
    width: 12%;
    white-space: nowrap;
  }

  .sales,
  .profit,
  .steam-price {
    padding-left: 32px;
  }

  .profit {
    width: 10%;
    margin-right: auto;
  }

  .sales {
    width: 10%;
    margin-left: auto;
  }

  &.is-header {
    background: var(--accent-on-primary);
    position: sticky;
    top: 14rem;
    z-index: 1;
    border-radius: 0;

    .left {
      width: 309px;
    }

    .sales,
    .steam-price {
      padding-left: 4px;
    }

    .profit {
      padding-left: 20px;
    }

    .prices-wrapper {
      padding-left: 0;
    }

    .prices-wrapper:deep(.cselect_top) {
      background: var(--surfaces-high-container);
      height: 4rem;
      min-height: 4rem;
    }

    @media screen and (max-width: 1400px) {
      top: 16rem;
    }
  }

  @media screen and (max-width: 1500px) {
    zoom: 0.9;
  }
  @media screen and (max-width: 1115px) {
    zoom: 1;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    gap: 12px;
    max-width: 400px;

    .item-rarity-color,
    .btn-like {
      display: none;
    }
    .prices-wrapper {
      order: 999;
    }

    .profit,
    .steam-price,
    .sales,
    .left {
      width: 100%;
    }

    .sales,
    .profit,
    .steam-price,
    .prices-wrapper {
      padding-left: 0;
    }

    .profit,
    .sales {
      margin-right: 0;
    }
    .left {
      margin-bottom: 8px;
    }
    .prices-wrapper {
      margin-top: 8px;
      width: 100%;
      min-width: unset;
      justify-content: space-between;

      &:deep(.btn:not(.swap-btn)) {
        background: var(--surfaces-high-container);
      }

      &:deep(.min-price),
      &:deep(.max-price) {
        width: 100%;

        .btn.btn-transparent {
          justify-content: center;
        }
      }
    }

    &.is-header {
      top: 4rem;
      padding: 0 0 10px 0;
      gap: 0;

      .left,
      .sales,
      .steam-price,
      .profit {
        display: none;
        margin: 0;
        padding: 0;
      }

      .prices-wrapper .min-price {
        &:deep(.cselect_dropdown) {
          right: unset;
        }
      }

      .prices-wrapper .max-price {
        &:deep(.cselect_dropdown) {
          left: unset;
        }
      }
    }
  }
}
</style>
